export default {"src":"/_next/static/media/BlossmLogoSmallBlack.a7d7a84e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};